import type { FunctionComponent } from "react"
import type { WithLinkFragment as LinkEntry } from "~/contentful"
import ResponsiveContentfulImage from "../ResponsiveContentfulImage"
import HorizontalDataList from "./HorizontalDataList"

const HeaderActivitiesPopover: FunctionComponent<{
  links: LinkEntry[]
  closePopover: () => void
}> = ({ links, closePopover }) => {
  const promoLinks = links.slice(0, 8)

  const linkCards = promoLinks.map(link => (
    <a
      key={link.sys.id}
      href={link.url!}
      className="block w-32 lg:w-52"
      onClick={closePopover}
    >
      <span className="mb-3 block">
        <h3 className="text-center font-serif">{link.title}</h3>
      </span>
      <span className="block w-32 lg:w-52">
        {link.image?.url && (
          <ResponsiveContentfulImage
            src={link.image.url}
            width={link.image.width ?? undefined}
            height={link.image.height ?? undefined}
            sizeMobile="200px"
            sizeDesktop="200px"
            alt=""
            className="block h-full w-full overflow-hidden rounded-xl object-contain"
          />
        )}
      </span>
    </a>
  ))

  return (
    <div className="w-screen max-w-camp-container-limit px-12 py-8 text-camp-primary">
      <HorizontalDataList items={linkCards} onClick={closePopover} />
    </div>
  )
}

export default HeaderActivitiesPopover
